import React from 'react'
import { ConfigWithFences } from '@src/lib/apiClient'

export type ConfigContextType = {
  configContext: ConfigWithFences;
  setConfigContext: (config: ConfigWithFences) => void;
}

const emptyConfig = {} as ConfigWithFences
export const ConfigContext = React.createContext<ConfigContextType>({
  configContext: emptyConfig,
  setConfigContext: () => { /* noop */ },
})

type Props = {
  children?: React.ReactNode
};
export const ConfigContextProvider: React.FC<Props> = ({ children }) => {
  const [configContext, setConfigContext] = React.useState<ConfigWithFences>(emptyConfig)
  return (
    <ConfigContext.Provider
      value={{ configContext, setConfigContext }}
    >
      { children }
    </ConfigContext.Provider>
  )
}
